import React from 'react';
import { Optional, Box, BadgeAlert } from '@honda-canada/design-system-react';
import { useTranslation } from 'react-i18next';
var CardStatusBadge = function (_a) {
    var status = _a.status, badgeAlignment = _a.badgeAlignment;
    var t = useTranslation().t;
    if (!status)
        return null;
    return (React.createElement(Box, { style: { display: 'flex', justifyContent: badgeAlignment } },
        React.createElement(Optional, { when: status === 'lowInventory' },
            React.createElement(BadgeAlert, { variant: "warning", labelText: t('Shared.Common.limitedInventoryLabel'), iconSize: "default", iconName: "warning", dataTestId: "cy-status-badge" })),
        React.createElement(Optional, { when: status === 'soldOut' },
            React.createElement(BadgeAlert, { variant: "warning", labelText: t('Shared.Common.soldOutLabel'), iconSize: "default", iconName: "warning", dataTestId: "cy-status-badge" }))));
};
export default CardStatusBadge;
